import { EmptyResult, OrderBox } from "..";
import { OrderModel } from "../../models";
import Skeleton from "react-loading-skeleton";
import { isEmpty } from "../../helpers";

type Props = {
  isLoading: boolean;
  orders: OrderModel[];
  onTrack: (order: OrderModel) => void;
  onShow: (order: OrderModel) => void;
};

const Orders: React.FC<Props> = ({ isLoading, orders, onTrack, onShow }) => {
  return (
    <>
      {isLoading && <Skeleton count={10} height={100} className="mb-3" />}

      {!isLoading && isEmpty(orders) && (
        <EmptyResult message="No orders found" />
      )}

      {orders.map((order, key) => (
        <OrderBox
          key={key}
          order={order}
          onTrack={() => onTrack(order)}
          onShow={() => onShow(order)}
        />
      ))}
    </>
  );
};

export default Orders;
